import Vue from 'vue'
import Vuex from 'vuex'
import routes from './modules/routes'
import operate from './modules/operate'
import operated from './modules/cheng/store'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    routes,
    operate,
    operated
  },
  state: {
    adSwitch: false,
    sideBarSwitch: false,
    uploadStatus: false
  },
  getters: {
    adSwitch: state => {
      return state.adSwitch
    },
    sideBarSwitch: state => {
      return state.sideBarSwitch
    },
    uploadStatus: state => {
      return state.uploadStatus
    }
  },
  mutations: {
    handleAdSwitch (state, value) {
      state.adSwitch = value
    },
    handleSideBarSwitch (state, value) {
      state.sideBarSwitch = value
    },
    handleUploadStatus (state, value) {
      state.uploadStatus = value
    },
    setplatformId (state, data) { state.operated.state.firsrd = data },
    setend_time (state, data) { state.operated.state.end_time = data },
    setstated(state,data){state.operated.state.stated = data },
    setapplytit(state,data){state.operated.state.applytit = data},
    setodercred(state,data){state.operated.state.odercred = data},
  },
  actions: {}
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js